import * as Yup from 'yup'

export const rejeitarNotaSchema = Yup.object().shape({
  motivo: Yup.string().trim().required('O motivo é obrigatório'),
})
